class coverageType {
  constructor(msg) {
    this.items = {
      id: 30001,
      name: "Vehicle Make",
      type: "text",
      slideimg: "/doctorassistant/dia.jpg",
      options: [
        {
          id: 40012,
          text: "Individual",
          name: "Individual",
          type: "duration",
          desc: "I’d like to get the Individual coverage",
          key: "coverageType",
          value: 0,
          inputtype: "button",
        },
        {
          id: 40012,
          text: "Family",
          name: "Family",
          type: "duration",
          desc: "I’d like to get the Family coverage",
          key: "coverageType",
          value: 1,
        },
        // {
        //   id: 40011,
        //   text: "Other",
        //   name: "Other",
        //   type: "coverageType",
        //   desc: "Other",
        //   inputtype: "textinput",
        //   key: "make",
        //   value: "Other",
        // },
      ],
      backtostart: true,
      text: [
        `<p>Great! Now, please select the coverage type of your ${
          msg.inputtext ? msg.inputtext : msg.desc
        } travel.</p> `,
      ],
    };
  }

  getAllItems() {
    return this.items;
  }
}

export default coverageType;
